import { Flex } from "antd";
import { TooltipProps } from "recharts";
// eslint-disable-next-line import/no-unresolved
import { ValueType, NameType } from "recharts/types/component/DefaultTooltipContent";

import { ChartType } from "domains/altCustody/shared/constants";
import { currencyFormatter } from "domains/liquidity/shared/utils/inputValueFormatter";

import "./CustomChartTooltip.scss";

interface IProps extends TooltipProps<ValueType, NameType> {
  type: `${ ChartType }`;
}

const CustomChartTooltip = ({ type, active, payload }: IProps) => {
  if (active && payload && payload.length) {
    const label = type === ChartType.PIE ? payload[ 0 ].name : payload[ 0 ].payload.name;
    const dataValue = (payload as any)[ 0 ].payload.total_nav || (payload as any)[ 0 ].payload.value;
    const isNegative = (payload as any)[ 0 ].payload.isNegative;

    return (
      <Flex align="center" className="custom-tooltip-container">
        <p className="label">{`${ label }: ${ isNegative ? '- ' : '' }${ currencyFormatter(Number(dataValue)) }`}</p>
      </Flex>
    );
  }

  return null;
};

export default CustomChartTooltip;
